// import { h } from 'preact';
import { useState } from 'preact/hooks';

const useOpenSign = (override) => {
  const [isOpen, setIsOpen] = useState(() => {
    return localStorage.getItem('store-status') || undefined;
  });

  window.addEventListener('store-status', (e) => {
    setIsOpen(e.detail.isStoreOpen);
  });

  return override ? true : isOpen;
};

export default useOpenSign;
